import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { num } from "../posHelpers";

/** Two-decimal money with thousands separators. */
export const amt = (value) =>
  num(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const day = (value) => (value ? dayjs(value).format("DD MMM YYYY") : "—");
export const time = (value) => (value ? dayjs(value).format("hh:mm A") : "—");

export const PageHead = ({ title, subtitle, children }) => (
  <div className="pm-head">
    <div>
      <h4>{title}</h4>
      {subtitle ? <p>{subtitle}</p> : null}
    </div>
    {children ? <div className="pm-head__actions">{children}</div> : null}
  </div>
);

PageHead.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  children: PropTypes.node,
};

export const Stat = ({ label, value, hero }) => (
  <div className={`pm-stat ${hero ? "pm-stat--hero" : ""}`.trim()}>
    <div className="pm-stat__k">{label}</div>
    <div className="pm-stat__v">{value}</div>
  </div>
);

Stat.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  hero: PropTypes.bool,
};

/** The totals every shift / day carries (API PosTotals): sales, returns, tenders. */
export const TotalsStats = ({ t }) => (
  <div className="pm-stats">
    <Stat label="Bills" value={t?.billCount ?? 0} />
    <Stat label="Sales" value={amt(t?.salesTotal)} />
    <Stat label={`Returns (${t?.returnCount ?? 0})`} value={amt(t?.returnTotal)} />
    <Stat label="Net" value={amt(t?.netTotal)} hero />
    <Stat label="Cash" value={amt(t?.cash)} />
    <Stat label="Card" value={amt(t?.card)} />
    <Stat label="UPI" value={amt(t?.upi)} />
    <Stat label="Credit" value={amt(t?.credit)} />
  </div>
);

TotalsStats.propTypes = { t: PropTypes.object };

/** Counted minus expected cash: short in red, excess in green. */
export const CashDiff = ({ value }) => {
  const v = Math.round(num(value) * 100) / 100;
  if (!v) return <span>0.00</span>;
  return v < 0 ? (
    <span className="pm-diff--short">Short {amt(-v)}</span>
  ) : (
    <span className="pm-diff--excess">Excess {amt(v)}</span>
  );
};

CashDiff.propTypes = { value: PropTypes.number };

export const Empty = ({ children }) => <div className="pm-empty">{children}</div>;

Empty.propTypes = { children: PropTypes.node };
